<div class="info" [@zoomIn]="true">
    <div class="container-fluid head">
        <div *ngIf="pdv?.image" class="row image" oncontextmenu="return false;" [ngClass]="{loading:!loadAvatar}">
            <img [alt]="pdv?.name" loading [src]="pdv.image|absolutePath:'img'" style="position: relative" width="100%"
                (load)="loadAvatar=true">
        </div>
    </div>
    <div class="container">
        <div class="row livraison">
            <div class="col-md-6">
                <h3 class="heading" *ngIf="pdv?.comment">Le Restaurant :</h3>
                <hr class="half_space" *ngIf="pdv?.comment">
                <div *ngIf="pdv?.comment" [innerHtml]="pdv?.comment" class="comment"></div>
                <h3 class="heading">Contact</h3>
                <hr class="half_space">
                <div class="content-contact">
                    <div class="head-contact">
                        <span class="img">
                            <img src="assets/images/icons/contact.png" width="60px" alt="">
                        </span>
                    </div>
                    <div class="body">
                        <p>
                            <img src="assets/images/restaurant.svg" style="margin-right: 6px;" width="32px" [alt]="pdv?.name">
                            {{pdv?.name}}
                        </p>
                        <p class="address">
                            <i class="flaticon-pin"></i>
                            <a href="#" #maplink target="_blank"> {{pdv?.address}}</a>
                        </p>
                        <p class="phone">
                            <i class="flaticon-phone-on-circle"></i>
                            <a href="tel:{{pdv?.phone}}">{{pdv?.phone}}</a>
                        </p>
                        <p class="email" *ngIf="pdv?.emailContact">
                            <i class="flaticon-arroba"></i>
                            <a href="mailto:{{pdv?.emailContact}}">
                                {{pdv?.emailContact}}
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <h3 class="heading">Zones de livraison</h3>
                <hr class="half_space">
                <div class="cont-zone">
                    <div class="row content" *ngFor="let zone of authorizedCities;">
                        <div class="col-md-8 left">
                            {{zone.name}} {{zone.postalCode}}
                        </div>
                        <div class="col-md-4 right">
                            <span class="cir">{{zone.amountMiniDelivery}} €</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="map"></div>